import React, { useEffect, useState } from "react";
import { useOnClickOutside } from "../hooks";

const links = {
    " Meeting Details": "#meeting",
    "Solo Travellers": "#solo",
    "About this walk": "#walk",
    "Your Accommodation": "#accommodation",
    "Tour Itinerary": "#itinerary",
    "What to Bring?": "#what-to-bring",
    "Cancellations & Conditions of Travel": "#conditions",
    // "COVID Policies on tour": "#policies",
};

const Navbar = ({ open, setOpen, reference, isTabletOrMobile }) => {
    const [activeLink, setActiveLink] = useState("");
    const [delayedOpen, setDelayedOpen] = useState(open);
    useOnClickOutside(reference, () => setOpen(false), open);

    useEffect(() => {
        if (open) {
            setDelayedOpen(true);
        } else {
            setTimeout(() => {
                setDelayedOpen(false);
            }, 500);
        }
    }, [open]);

    return isTabletOrMobile ? (
        delayedOpen && (
            <nav ref={reference} className={`nav-container ${open ? "open" : "close"} mobile`}>
                {Object.keys(links).map(key => (
                    <a
                        key={"mobile" + links[key]}
                        className={activeLink === key ? "active" : ""}
                        onClick={() => {
                            setActiveLink(key);
                            setOpen(false);
                        }}
                        href={links[key]}
                    >
                        {key}
                    </a>
                ))}
            </nav>
        )
    ) : (
        <nav ref={reference} className={`nav-container desktop`}>
            {Object.keys(links).map(key => (
                <a
                    key={links[key]}
                    className={activeLink === key ? "active" : ""}
                    onClick={() => {
                        setActiveLink(key);
                        setOpen(false);
                    }}
                    href={links[key]}
                >
                    {key}
                </a>
            ))}
        </nav>
    );
};

export default Navbar;
